export enum SupportWebChatConfig {
  // tagName = 'support-web-chat',
  FileName = 'chat.web-component.min.js',
  PortalName = 'RappiAliados',
}
